import React from "react";
import styled from "styled-components";
import colors from "../utils/colors";


const FooterContainer = styled.footer`
  background: ${colors.darkColor};
  box-shadow: 0 -0.8rem 2rem rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  width: 100%;
  display: grid;
  grid-template-columns: 1.2fr 1fr 0.8fr;
  gap: 2rem;
  text-align: left;
  font: bold 16px sans-serif;
  padding: 2.5rem clamp(1rem, 4vw, 4rem);
  margin-bottom: 0;

  @media screen and (max-width:770px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    width: 100%;
  }
`

const LeftSection = styled.div`
  width: 100%;

  @media screen and (max-width:770px) {
    font-size: 0.6rem;
  }
`

const Logo = styled.h3`
  color: ${colors.secondColor};
  font-size: 2.25rem;
  line-height: 1;
  margin: 0;

  @media screen and (max-width:770px) {
    font-size: 1.5rem;
    margin: 0;
  }
`

const LogoSpan = styled.span`
  color: ${colors.primaryColor};
`
const Devise = styled.span`
  color: ${colors.textColor};
  font: normal 1rem 'Open Sans', cursive; 
  display: inline-block;
  margin-top: 0.5rem;

  @media screen and (max-width:770px) {
    font-size: 0.7rem;
  }
`

const ServicesContainer = styled.p`
  color: ${colors.textColor};
  margin: 1.5rem 0 0;
  padding: 0;

  @media screen and (max-width:770px) {
    margin-top: 0;
    text-align: center;
  }
`

const Service = styled.span`
  display: inline-block;
  line-height: 1.8;
  font-weight: 400;
  text-decoration: none;
  color: inherit;

  &:before {
    content: "|";
    font-weight: 300;
    font-size: 20px;
    left: 0;
    color: #fff;
    display: inline-block;
    padding-right: 5px;
  }

  &:first-child:before {
    content: none;
  }
`

const CompanyName = styled.p`
  color: ${colors.primaryColor};
  font-size: 1rem;
  font-weight: normal;
  margin-top: 1rem;
`

const CenterSection = styled.div`
  width: 100%;

  @media screen and (max-width:770px) {
    width: 100%;
  }
`

const CenterItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
`

const Icon = styled.i`
  background-color: ${colors.darkBackground};
  color: ${colors.primaryColor};
  font-size: 25px;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  text-align: center;
  line-height: 42px;
  margin-right: 15px;

  @media screen and (max-width:770px) {
    font-size: 12px;
    width: 20px;
    height: 20px;
    line-height: 20px;
  }
  `

const CenterText = styled.p`
  color: ${colors.textColor};
  font-weight: 400;
  vertical-align: middle;
  margin: 0;
  
  @media screen and (max-width:770px) {
    font-size: 12px;
  }
`

const CenterLink = styled.a`
  color: ${colors.textColor};
  text-decoration: none;
  font-weight: none;

  &:hover {
    color: ${colors.primaryColor};
  }

  @media screen and (max-width:770px) {
    font-size: 12px;
  }
`

const RightSection = styled.div`
  width: 100%;

  @media screen and (max-width:770px) {
    width: 100%;
  }
`

const About = styled.p`
  line-height: 20px;
  color: ${colors.textColor};
  font-size: 13px;
  font-weight: normal;
  margin: 0;
  text-align: justify;
  
  @media screen and (max-width:770px) {
    font-size: 0.8rem;
  }
`

const AboutSpan = styled.span`
  display: block;
  color: ${colors.textColor};
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 20px;

  @media screen and (max-width:770px) {
    font-size: 12px;
    margin-bottom: 10px;
  }
`

const Footer = () => {

  const CurrentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <LeftSection>
        <Logo>
          ROMS<LogoSpan>services</LogoSpan>
        </Logo>
        <Devise>Le défi de l'excellence</Devise>
        <ServicesContainer>
          <Service>Comptabilité </Service>
          <Service>Fiscalité </Service>
          <Service>Gestion </Service>
          <Service>Import-Export </Service>
          <Service>Représentation Commerciale </Service>
          <Service>Agro-Bussiness </Service>
        </ServicesContainer>
      </LeftSection>
      <CenterSection>
        <CenterItem>
          <Icon className="bi bi-geo-alt-fill"></Icon>
          <CenterText>
            <span>Quartier Djidjolé</span> Lomé, Togo
          </CenterText>
        </CenterItem>
        <CenterItem>
          <Icon className="bi bi-telephone-fill"></Icon>
          <CenterLink href="tel:+22898939308">+228 98 93 93 08</CenterLink>
        </CenterItem>
        <CenterItem>
          <Icon className="bi bi-whatsapp"></Icon>
          <CenterLink href="https://wa.me/0022890990133?">+228 90 99 01 33</CenterLink>
        </CenterItem>
        <CenterItem>
          <Icon className="bi bi-envelope-fill"></Icon>
          <CenterText>
            <CenterLink href="mailto:roms.service85@gmail.com">roms.service85@gmail.com</CenterLink>
          </CenterText>
        </CenterItem>
      </CenterSection>
      <RightSection>
        <About>
          <AboutSpan>A propos de ROMS</AboutSpan>
          ROMS est une société spécialisée dans la gestion économique, les finances, la comptabilité,
          l'import-export, la consultation, et bien plus.
        </About>
        <CompanyName>Roms © {CurrentYear}</CompanyName>
      </RightSection>
    </FooterContainer>
  )
}

export default Footer
